import { useState } from "react";
import {
  IconContainer,
  WeatherInfoContainer,
  WeatherWidgetContainer
} from "./weatherWidget.styles";

const WeatherWidget = ({ weatherData, loading, error, onTrackButtonClick }) => {
  const [hidden, setHidden] = useState(false);

  const getWeatherIcon = (weatherCode) => {
    const weatherIcons = {
      0: "☀️",
      1: "🌤️",
      2: "⛅",
      3: "☁️",
      45: "🌫️",
      48: "🌫️",
      51: "🌧️",
      53: "🌧️",
      55: "🌧️",
      56: "🌧️",
      57: "🌧️",
      61: "🌧️",
      63: "🌧️",
      65: "🌧️",
      71: "❄️",
      73: "❄️",
      75: "❄️",
      77: "❄️",
      80: "🌧️",
      81: "🌧️",
      82: "🌧️",
      95: "⛈️",
      96: "⛈️",
      99: "⛈️"
    };
    return weatherIcons[weatherCode] || "❓";
  };

  if (loading) {
    return <p>Loading weather...</p>;
  }

  if (error) {
    console.log("Weather error: ", error);
    return null;
  }

  const {
    temperature_2m_min: minTemp,
    temperature_2m_max: maxTemp,
    weathercode
  } = weatherData?.daily;

  const todayMin = minTemp[0];
  const todayMax = maxTemp[0];
  const todayWeatherCode = weathercode[0];
  const weatherIcon = getWeatherIcon(todayWeatherCode);

  if (!weatherData?.daily) {
    return null;
  }

  return (
    <WeatherWidgetContainer
      hidden={hidden}
      onClick={() => {
        onTrackButtonClick?.(
          `${hidden ? "show" : "hide"}_weather_widget`,
          "weather_widget"
        );
        setHidden(!hidden);
      }}
    >
      <IconContainer>{weatherIcon}</IconContainer>
      <WeatherInfoContainer>
        <p>
          {Math.round(todayMin)}° / {Math.round(todayMax)}°
        </p>
      </WeatherInfoContainer>
    </WeatherWidgetContainer>
  );
};

export default WeatherWidget;
